import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index']);
  const createExpensesConfig = `createExpensesConfig(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createExpensesConfig} {
      id
    }
  }
`;
};
